export class CustomerCredit {
    available: number;
    balance: number;
    current: number;
    pastDue: number;
    prepay: number;
    booking: number;
    // time: string;
    isUnlimitedCredit: boolean;
}